import React, { useState, useEffect } from "react";
import { Element } from 'react-scroll';
import { scrollTo } from '../../helpers/generalHelpers';
import {
  Section,
  H1,
  H3,
  CardList,
  SubEventsBox,
  CityBox,
  RowCityInfo,
  CityName,
  RowCity,
  Date,
  Container,
  CardSubEvents,
  AgePlayers,
  AgeInfoPlayers,
  RowsAgesInfo,
  InfosSubCard,
  ButtonAction,
  WaitEvent
} from "./styles";
import CardEvent from "../Events/CardEvents";
import { defineMonth } from "../../helpers/sharedHelper";
import { ReactComponent as PlayerIcon } from "../../assets/img/player.svg";
import { ReactComponent as LocalIcon } from "../../assets/img/placeholder.svg";
import Athlete from "../../components/Forms/Athlete";
import School from "../../components/Forms/School";
import Swal from "sweetalert2";
import './modal.css'

import withReactContent from "sweetalert2-react-content";
const AlertPaym = withReactContent(Swal);
export default function Disclaimer({
  events,
  countries,
  atheleteRequest,
  schools,
  disclaimersRequestRegisterLeeds
}) {
  const [subEventsItems, setSubEvents] = useState({
    city: "",
    date: "",
    subEvents: []
  });
  const [eventOnFocus, setEventOnFocus] = useState(null);
  const [kindForm, setKindForm] = useState(null);
  const [eventSelected, setEventSelected] = useState(null);
  const [cardSelected, setCardSelected] = useState(null);
  const showEventInfos = subEvents => {
    setSubEvents({
      city: subEvents.cityName,
      date: subEvents.date,
      subEvents: subEvents.subEvents,
      eventIsOnHolding: subEvents.eventIsOnHolding
    });
  };

  const registerEvent = (kind, event, selectedItem) => {
    if (selectedItem.enrollment_closed) {
      AlertPaym.fire({
        title: "Este evento já encontra-se com as inscrições encerradas",
        icon: "info",
        confirmButtonText: "OK"
      });
    } else {
      setKindForm(kind);
      setEventSelected(event);
    }
  };

  const showDialog = (id) => {
    AlertPaym.fire({
      title: "Inscrições abertas em breve",
      input: "email",
      text: "Deixe seu email aqui, que entramos em contato",
      inputAttributes: {
        autocapitalize: "off"
      },
      validationMessage: "O e-mail não é válido",
      background: "#ABE523",
      confirmButtonText: "Enviar",
      showLoaderOnConfirm: true,
      preConfirm: login => {},
      allowOutsideClick: () => !AlertPaym.isLoading()
    }).then(result => {
      if (result.value) {
        disclaimersRequestRegisterLeeds({email: result.value, id})
        AlertPaym.fire({
          title: `Email cadastrado com sucesso`,
          icon: "success"
        });
      }
    }).catch( error => console.error(error));
  };

  useEffect(() => {
    setEventOnFocus(null)
    setKindForm(null)
    setEventOnFocus(null)
    setEventSelected(null)
  }, [cardSelected])

  return (
    <>
      <Section>
        <Container>
          <H1>
            SELECIONE O EVENTO PRESENCIAL MAIS PRÓXIMO DE VOCÊ E INSCREVA-SE!
          </H1>
          <H3>
            Essa é a sua chance de realizar o sonho de ser um jogador de
            futebol!
          </H3>
          <CardList>
            {events.map((event, index) => (
              <CardEvent
                selected={index === cardSelected}
                requestEventsInfo={() => {
                  showEventInfos(event)
                  setCardSelected(index)
                  scrollTo("subevents")
                }}
                key={index}
                {...event}
              />
            ))}
          </CardList>
        </Container>
      </Section>
      <Element name="subevents">
        {subEventsItems.subEvents.length > 0 && (
          <SubEventsBox>
            <RowCityInfo>
              <CityBox>
                <RowCity />
                <CityName>{subEventsItems.city}</CityName>
                <RowCity />
              </CityBox>
              <Date>
                {subEventsItems.eventIsOnHolding ? null : (
                  <>
                    {" "}
                    {subEventsItems.date.split("-")[2]}
                    {"  -  "}
                  </>
                )}

                {defineMonth(subEventsItems.date.split("-")[1])}
              </Date>
            </RowCityInfo>
            <CardList>
              {subEventsItems.subEvents.map((item, index) => {
                return (
                  <CardSubEvents
                    onMouseEnter={() => setEventOnFocus(index)}
                    onMouseLeave={() => setEventOnFocus(null)}
                    showOptions={eventOnFocus === index}
                  >
                  {eventOnFocus === index ? (
                    <div>
                      {item.status === "on_holding" ? (
                        <WaitEvent onClick={() => showDialog(item.event_id)}>
                          VAGAS SERÃO ABERTAS EM BREVE!
                        </WaitEvent>
                      ) : (
                        <>
                        {" "}
                        <ButtonAction
                          margin
                          onClick={() => {
                              registerEvent("athlete", eventOnFocus, item)
                              scrollTo("subevents-form")
                            }
                          }
                          >
                          ATLETA
                        </ButtonAction>
                        <ButtonAction
                          onClick={() => {
                              registerEvent("school", eventOnFocus, item)
                              scrollTo("subevents-form")
                            }
                          }
                          >
                          ESCOLINHA
                        </ButtonAction>
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      <RowsAgesInfo>
                        <PlayerIcon />
                        <AgePlayers>
                          {item.age_min} à {item.age_max}
                        </AgePlayers>
                        <AgeInfoPlayers>
                          Anos
                        </AgeInfoPlayers>
                      </RowsAgesInfo>
                      <InfosSubCard>{item.price}</InfosSubCard>
                      <InfosSubCard>
                        {item.status === "active" ? (
                            <>
                              <LocalIcon />
                              {item.address.neighborhood} {"- "}
                              {item.address.city}
                            </>
                          ) : (
                            <>
                              <LocalIcon />
                              {defineMonth(subEventsItems.date.split("-")[1])}
                              {" - "}
                              {item.address.city}
                            </>
                          )}
                        </InfosSubCard>
                      </>
                    )}
                  </CardSubEvents>
                );
              })}
            </CardList>
          </SubEventsBox>
        )}
      </Element>
      <Element name="subevents-form">
        {kindForm === "athlete" && (
          <Athlete
            successRegisterRestartForm={() => setKindForm(null)}
            event={subEventsItems.subEvents[eventSelected]}
            atheleteRequest={atheleteRequest}
            countries={countries}
          />
        )}
        {kindForm === "school" && (
          <School
            event={subEventsItems.subEvents[eventSelected]}
            atheleteRequest={atheleteRequest}
            countries={countries}
            schools={schools}
          />
        )}
      </Element>
    </>
  );
}
